<template>
  <!-- https://stackoverflow.com/questions/61444870/maximum-call-stack-size-exceeded-vuetify -->
  <v-dialog
    v-model="dialog"
    max-width="600"
    :retain-focus="false"
    persistent
  >
    <v-card class="primary p-4">
      <div
        class=" navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head"
      >
        <v-icon class="white--text" left>design_services</v-icon>
        <span class="white--text" style="font-size: 18px"
          >PIANIFICAZIONE ROSA</span
        >
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="navy darken-1 white--text pa-4">

         <!-- info -->
         <v-alert dense text type="info" class="mb-4">
            Puoi usare Asta Live ignorando la 'Pianificazione Rosa'.<br>
            Tuttavia ti incoragggiamo fortemente a usarla perché ti aiuta a non fare pazzie durante le concitate fasi d'asta e rimanere equilibrato.
          </v-alert>

       <!-- alert mantra  -->
            <div v-if="mantra">
               <v-alert dense text type="info" class="">
            Sebbene sia una lega a Mantra, per la
            pianificazione dei ruoli da acquistare si fa riferimento ai ruoli
            <b>classici</b> (identificabili dal bordo sinistro del rettangolo
            intorno al calciatore)
               </v-alert>
          </div>


        <!-- numero calciatori -->
        <div
          v-if="asta_info.lega.nRuoli.op == 'illimitati'"
          class="d-flex flex-column pt-4"
        >
          <div>
            <div class="text-uppercase font-weight-bold mb-2">
              Numero calciatori
            </div>
             <div class="mb-2">In questa lega ci sono acquisti "illimitati / a piacere". Per poter
            procedere a una pianificazione devi innanzitutto impostare quanti
            calciatori intendi acquistare per ciascun ruolo</div>

          </div>
          <div class="d-flex align-center">
            <v-select
              class="ma-1"
              :class="{ invalido: !nP_items.includes(nP) }"
              v-model="nP"
              :items="nP_items"
              label="P"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              :class="{ invalido: !nD_items.includes(nD) }"
              v-model="nD"
              :items="nD_items"
              label="D"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              :class="{ invalido: !nC_items.includes(nC) }"
              v-model="nC"
              :items="nC_items"
              label="C"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
            <v-select
              class="ma-1"
              v-model="nA"
              :class="{ invalido: !nA_items.includes(nA) }"
              :items="nA_items"
              label="A"
              required
              solo
              flat
              dense
              hide-details
            ></v-select>
          </div>
        </div>

        <!-- strategia -->
        <div class="d-flex flex-column pt-4">
            <div class="text-uppercase font-weight-bold mb-2">
              1. Pianifica crediti slot
            </div>
            <div class="mb-2">Hai 2 modi per pianificare i crediti da spendere per ogni slot:</div>
            <div class="mb-2"> <v-icon class="white--text">chevron_right</v-icon> Manualmente cliccando su "..."</div>
            <div class="mb-2"><v-icon class="white--text">chevron_right</v-icon>
             Automaticamente <v-btn
              outlined
              x-small
              color="secondary"
              class="px-1 font-weight-bold"
              @click="promptStrategia"
            >
              cliccando qui
            </v-btn>. Tranquillo, potrai sempre modificarli singolarmente dopo.</div>
        </div>

        <div class="d-flex flex-column pt-4">
            <div class="text-uppercase font-weight-bold mb-2">
              2. Pianifica "Calciatori Obiettivi" slot (opzionale)
            </div>
            <div class="mb-2">Opzionalmente puoi aggiungere i calciatori obiettivo (quelli che vorresti acquistare)
              per ogni slot: nella tabella precedente clicca su "Aggiungi Obiettivo". Puoi aggiungere piú obiettivi per ciascun slot. </div>
        </div>

        <div class="d-flex flex-column pt-4">
            <div class="text-uppercase font-weight-bold mb-2">
              Et voilá.
            </div>
            <div class="mb-2">
              Durante l'asta man mano che acquisti calciatori:
               <ul>
                  <li>
                    Asta Live inserisce in automatico il calciatore comprato
                    nello slot adeguato (sostituendo i crediti pianificati con
                    quelli effettivamente spesi)
                  </li>
                  <li>
                    Se hai speso di più o di meno di quanto pianificato per
                    quello slot, <b class="accent--text">Asta Live ti avvisa quanti crediti devi
                    ridistribuire tra gli slot liberi rimanenti</b>
                  </li>
                  <li>
                    Rimuove automaticamente dalla tua lista gli obiettivi non
                    più disponibili
                  </li>
                </ul>
            </div>
        </div>

        <!-- accordion -->
        <v-expansion-panels flat  class="mb-4">
          <v-expansion-panel>
            <v-expansion-panel-header class="font-hemi-head">
              FAQ / Domande frequenti
              <template v-slot:actions>
                <v-icon class="text--white">fa-caret-down </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                 <div class="pt-2 navy--text text--darken-2">
                  <b
                    >E' obbligatorio usare la Pianificazione?</b
                  >
                </div>
                <div>
                  No. Puoi usare Asta Live ignorando completamemte la pianificazione
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Perchè sono scomparsi dei calciatori dalla mia lista
                    obiettivi?</b
                  >
                </div>
                <div>
                  Perchè non sono più disponibili tra gli svincolati: o sono
                  stati acquistati (da qualcun altro o da te), o sono stati
                  scartati, o non giocano più nel campionato
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Con che logica Asta Live sceglie in quale slot inserire il
                    calciatore appena acquistato?</b
                  >
                </div>
                <div>
                  - Quando acquisti un calciatore presente nella "Lista Obiettivi", Asta Live lo inserisce automaticamente nel relativo slot.<br>
                  - Quando invece acquisti un calciatore che non hai messo nella "Lista Obiettivi",
                  Asta Live lo inserisce nello slot libero in cui i crediti spesi sono il più possibile simili a quelli pianificati.
                  Se non hai pianificato crediti per quel ruolo, usa il primo slot libero.
                </div>
                <div class="pt-2 navy--text text--darken-2">
                  <b
                    >Asta Live mi ha inserito un calciatore acquistato in un
                    certo slot ma io vorrei inserirlo in un altro</b
                  >
                </div>
                <div>
                  Non c'è problema. Puoi toglierlo dallo slot (premendo sulla "x")
                  e poi inserirlo in un altro slot (premendo sul "+" che comparirá)
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>


      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import db from "../../js/db";

export default {
  name: "dialog-plan-settings",
  mixins: [mixins, toast],
  components: {},
  mounted() {
    console.log("--> DialogPlanSettings mounted.");
    db.on("DialogPlanSettings", this.show);
  },
  destroyed() {
    console.log("<-- DialogPlanSettings destroyed.");
    db.off("DialogPlanSettings", this.show);
  },
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    // planDefault: {
    //   type: Object,
    //   required: true,
    // },
  },
  methods: {
    dismiss() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    promptStrategia() {
      this.dismiss();
      db.emit("DialogPlanStrategia");
    },
  },
  computed: {
    nP_items() {
      const ruolo_id = 1;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nD_items() {
      const ruolo_id = 2;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nC_items() {
      const ruolo_id = 3;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nA_items() {
      const ruolo_id = 4;
      const squadra_id = this.my_squadra.id;
      const min = this.acquistiPerRuolo(ruolo_id, squadra_id) || 1;
      return _.range(min, 25); // per avere 24
    },
    nP: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nP;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nP", value);
      },
    },
    nD: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nD;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nD", value);
      },
    },
    nC: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nC;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nC", value);
      },
    },
    nA: {
      get() {
        return this.my_squadra.settings.plan.nRuoli.nA;
      },
      set(value) {
        db.setSettingsPlanNRuoli("nA", value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.v-expansion-panel-header {
  background: var(--v-navy-darken2);
  color: white;
}

.invalido {
  box-shadow: 0 0 0px 2px var(--v-error-base);
}
</style>
